<!-- eslint-disable @angular-eslint/template/cyclomatic-complexity -->
<div
  *ngIf="!isPostBookingPage && (isMobile || (!isMobile && !isCheckoutPage))"
  class="main-menu__container"
  [ngClass]="{
    'main-menu__container--menu-open': menuIsOpen,
    'main-menu__container--menu-hidden': isMobile && langSwitcherIsOpen && menuIsOpen
  }"
>
  <div *ngIf="isMobile" class="main-menu__elements-wrap main-menu__user-profile">
    <h5
      *ngIf="isLoggedIn && profile && (profile.firstName || profile.lastName); else emptyUserIcon"
      class="main-menu__user-profile-initials"
    >
      {{ profile.firstName?.charAt(0) }}{{ profile.lastName?.charAt(0) }}
    </h5>
    <ng-template #emptyUserIcon>
      <i class="fa-regular fa-user-circle main-menu__user-profile-icon"></i>
    </ng-template>
    <div class="main-menu__user-profile-content">
      <ng-container *ngIf="isLoggedIn && profile && (profile.firstName || profile.lastName); else emptyProfile">
        <h4 class="main-menu__user-profile-name">{{ profile.firstName }} {{ profile.lastName }}</h4>
        <span class="main-menu__user-profile-member">{{ 'limeloyalty.member' | translate }}</span>
      </ng-container>
      <ng-template #emptyProfile>
        <h4 class="main-menu__user-profile-name">{{ 'header-menu.profile-title' | translate }}</h4>
        <p class="main-menu__user-profile-tips">{{ 'header-menu.profile-text' | translate }}</p>
      </ng-template>
    </div>
    <button
      *ngIf="!isLoggedIn"
      type="button"
      id="qa_account-login--mobile"
      class="button main-menu__btn"
      (click)="openAuthModal($event)"
    >
      <span>{{ 'header-menu-signup' | translate }} / {{ 'header-menu-login' | translate }}</span>
    </button>
  </div>
  <nav class="main-menu__list" [ngClass]="!!viewPortWith ? 'main-menu__list--viewport-' + viewPortWith : ''">
    <div class="main-menu__elements-wrap">
      <span *ngIf="isMobile" class="main-menu__item-mobile-title"> {{ 'header-menu.community' | translate }}</span>
      <ng-template
        [ngTemplateOutletContext]="{
          title: mainMenu.membership.titleDesktop,
          titleMobile: mainMenu.membership.titleMobile,
          icon: mainMenu.membership.icon,
          href: mainMenu.membership.href,
          id: mainMenu.membership.id
        }"
        [ngTemplateOutlet]="menuItemWithoutDropdown"
      >
      </ng-template>
      <ng-template
        [ngTemplateOutletContext]="{
          title: mainMenu.groupBooking.titleDesktop,
          titleMobile: mainMenu.groupBooking.titleMobile,
          icon: mainMenu.groupBooking.icon,
          href: mainMenu.groupBooking.href,
          id: mainMenu.groupBooking.id
        }"
        [ngTemplateOutlet]="menuItemWithoutDropdown"
      >
      </ng-template>
    </div>

    <button
      *ngIf="!isMobile"
      #dropdownRef
      class="main-menu__aka-button main-menu__item"
      type="button"
      tabindex="0"
      aria-haspopup="true"
      [attr.aria-expanded]="isDropdownOpen"
      (click)="toggleDropdown()"
      (keydown)="handleKeydown($event)"
    >
      <div>
        <span>
          {{ mainMenu.realEstate.titleDesktop | translate | translate }}
        </span>
        <i class="fa-regular fa-angle-down"></i>
      </div>

      <div
        *ngIf="isDropdownOpen"
        class="main-menu__open main-menu__links-list"
        role="menu"
        [attr.aria-hidden]="!isDropdownOpen"
      >
        <ul [ngClass]="isMobile ? 'collapsable__list' : 'overlay__list'">
          <li
            *ngFor="let menuItem of mainMenu.realEstate.menuItems; let i = index"
            [ngClass]="isMobile ? 'collapsable__item' : 'overlay__item'"
          >
            <a
              role="menuitem"
              [id]="menuItem.id"
              href="{{ menuItem.href | localize }}"
              [ngClass]="isMobile ? 'main-menu__link' : 'overlay__link main-menu__link'"
            >
              <i class="fa-regular {{ menuItem.icon }} overlay__item-icon"></i>
              <span>
                {{
                  menuItem.titleMobile && isMobile
                    ? (menuItem.titleMobile | translate)
                    : (menuItem.titleDesktop | translate)
                }}</span
              >
              <i *ngIf="isMobile" class="fa-regular fa-angle-right overlay__item-icon-arrow"></i>
            </a>
          </li>
        </ul>
      </div>
    </button>

    <!-- New Mobile Menu -->
    <div
      *ngIf="isMobile"
      class="main-menu__elements-wrap main-menu__item main-menu__item--link main-menu__item--dropdown"
    >
      <span class="main-menu__item-mobile-title">
        {{ mainMenu.realEstate.titleMobile || mainMenu.realEstate.titleDesktop | translate | translate }}
      </span>
      <ul class="main-menu__links-list">
        <li *ngFor="let menuItem of mainMenu.realEstate.menuItems; let i = index">
          <a role="menuitem" tabindex="0" class="main-menu__link" href="{{ menuItem.href | localize }}">
            <i class="fa-regular {{ menuItem.icon }} overlay__item-icon"></i>
            <span>
              {{
                menuItem.titleMobile ? (menuItem.titleMobile | translate) : (menuItem.titleDesktop | translate)
              }}</span
            >
            <i *ngIf="isMobile" class="fa-regular fa-angle-right overlay__item-icon-arrow"></i>
          </a>
        </li>
      </ul>
    </div>
  </nav>
</div>

<div class="main-menu">
  <div *ngIf="!isMobile && isPDP" class="form inner-booking-widget main-menu__booking-widget">
    <app-city-picker
      [isListingRedirection]="true"
      [isPDPTracking]="true"
      [searchPlaceholderText]="'city-picker.search-placeholder-text'"
      [labelText]="'city-picker.label-text'"
      [isHeaderSearch]="true"
      [classList]="'inner inner-header'"
    />
  </div>
  <ng-container [ngTemplateOutlet]="helpCenterLinkTemplate" />
  <a
    *ngIf="isLoggedIn && ((!isMobile && !isPDP) || isDesktop)"
    class="main-menu__item tooltip_container"
    [routerLink]="['/my-bookings']"
    (click)="onMenuItemClick()"
  >
    <i class="item-lang__icon fa-regular fa-suitcase-rolling"></i>
    <span class="tooltip__text tooltip__text--bottom">
      {{ 'header-menu-booking' | translate }}
    </span>
  </a>
  <div *ngIf="showDivider" class="main-menu__divider"></div>
  <div
    class="main-menu__item item-lang tooltip_container"
    [ngClass]="{
      'item-lang--menu-opened': isMobile && menuIsOpen
    }"
  >
    <span *ngIf="!langSwitcherIsOpen && !isMobile" class="tooltip__text tooltip__text--bottom">
      {{ 'language.select' | translate }}
    </span>
    <a
      href="#"
      id="qa_header-lang"
      data-testid="qa-header-language"
      appOpenDropdown
      [ngClass]="'item-lang__dropdown' + (navOverlaysState.langSwitcher ? ' item-lang__dropdown--active' : '')"
      (click)="toggleLangSwitcher()"
    >
      <i class="item-lang__icon fa-regular fa-globe"></i>
      <span class="item-lang__code">{{ langParam }}</span>
    </a>
    <div
      class="overlay overlay--dropdown"
      data-testid="qa-lang-dropdown"
      appClickOutside
      [ngClass]="{
        'overlay--lang': isMobile,
        'overlay--lang--active': langSwitcherIsOpen
      }"
      (clickOutside)="closeLangSwitcher()"
    >
      <div class="overlay__content">
        <ng-container *ngIf="isMobile">
          <div class="overlay__lang-header">
            <i class="fa-regular fa-arrow-left overlay__close" (click)="toggleLangSwitcher()"></i>
            <h6 class="overlay__lang-header-title">{{ 'account-menu.language-item' | translate }}</h6>
          </div>
          <div class="main-menu__elements-wrap overlay__lang-info">
            <span class="overlay__lang-info-title">{{ 'language.header-title' | translate }}</span>
            <p class="overlay__lang-info-text">{{ 'language.header-subtitle' | translate }}</p>
            <ng-container *ngFor="let lang of languagesConfig">
              <ng-container *ngIf="langParam === lang.code">
                <span class="overlay__lang-info-selected">{{ lang.name }}</span>
              </ng-container>
            </ng-container>
          </div>
        </ng-container>
        <ul
          class="overlay__list main-menu__elements-wrap main-menu__elements-wrap--lang"
          data-testid="qa-account-dropdown-menu-list"
          [ngClass]="{
            'overlay__list--lang': isMobile
          }"
        >
          <ng-container *ngFor="let lang of languagesConfig; let i = index">
            <li class="overlay__item overlay__item--lang">
              <a
                href="#"
                class="overlay__link overlay__link--lang"
                [ngClass]="{
                  'overlay__link--lang-active':
                    isMobile && selectedLang ? selectedLang === lang.code : langParam === lang.code
                }"
                id="qa_lang-{{ lang.code }}"
                [attr.data-testid]="'qa-lang-' + lang.code"
                (click)="isMobile ? selectLanguage($event, lang.code) : switchLanguage($event, lang.code)"
              >
                <div class="flag-wrapper">
                  <img
                    class="overlay__flag"
                    alt=""
                    [src]="imgixHost + '/website/svg/header/flag-' + lang.code + '.svg'"
                    [attr.aria-label]="
                      langParam === lang.code ? 'Selected language: ' + lang.name : 'Switch language to ' + lang.name
                    "
                  />
                </div>
                {{ lang.name }}
                <ng-container *ngIf="isMobile">
                  <i
                    *ngIf="selectedLang ? selectedLang !== lang.code : langParam !== lang.code"
                    class="fa-regular fa-circle overlay__selector-icon"
                  ></i>
                  <i
                    *ngIf="selectedLang ? selectedLang === lang.code : langParam === lang.code"
                    class="fa-regular fa-dot-circle overlay__selector-icon"
                  ></i>
                </ng-container>
                <ng-container *ngIf="!isMobile">
                  <i *ngIf="langParam === lang.code" class="fa-regular fa-check overlay__check-icon"></i>
                </ng-container>
              </a>
            </li>
          </ng-container>
        </ul>
        <button
          *ngIf="isMobile"
          type="button"
          id="qa_save-language"
          class="button main-menu__btn main-menu__btn--save"
          [disabled]="!selectedLang"
          (click)="switchLanguage($event, selectedLang)"
        >
          <span>{{ 'button.save-text' | translate }}</span>
        </button>
      </div>
    </div>
  </div>
  <div
    *ngIf="isBrowser"
    class="main-menu__item item-account__dropdown main-menu__item--dropdown"
    data-testid="qa-account-icon-dropdown"
    [ngClass]="{
      'item-account__dropdown--hidden': isMobile && menuIsOpen
    }"
  >
    <a
      href="javascript:void(0)"
      class="item-account__icon"
      data-testid="qa-account-icon-link"
      appOpenDropdown
      aria-haspopup="true"
      aria-label="Open account menu"
    >
      <div
        class="item-account__icon-wrap"
        [ngClass]="{
          'item-account__icon-wrap--logged-in': isLoggedIn
        }"
      >
        <h6
          *ngIf="isLoggedIn && profile && (profile.firstName || profile.lastName); else userIcon"
          class="item-account__title"
        >
          {{ profile.firstName?.charAt(0) }}{{ profile.lastName?.charAt(0) }}
        </h6>
        <ng-template #userIcon>
          <i class="fa-regular fa-user-circle user__sidebar-user-icon"></i>
        </ng-template>
      </div>
    </a>
    <div
      class="overlay overlay--dropdown overlay--my-account"
      data-testid="qa-account-dropdown-menu"
      [ngClass]="{
        collapsable: isMobile
      }"
    >
      <div class="overlay__content">
        <ul class="overlay__list overlay__list--account" data-testid="qa-account-dropdown-menu-list">
          <!-- menu items when not logged in -->
          <ng-container *ngIf="!isLoggedIn">
            <li class="overlay__item">
              <a
                href="#"
                class="overlay__link main-menu__link"
                id="qa_account-login--desktop"
                data-testid="qa-account-login--desktop"
                (click)="openAuthModal($event, authModalType.logIn)"
              >
                <i class="fa-regular fa-arrow-right-to-arc overlay__item-icon"></i>
                <span>{{ 'header-menu-login' | translate }}</span>
              </a>
            </li>
            <li class="overlay__item">
              <a
                id="qa_account-signup--desktop"
                data-testid="qa-account-signup-link--desktop"
                href="#"
                class="overlay__link main-menu__link"
                (click)="openAuthModal($event, authModalType.signUp)"
              >
                <i class="fa-regular fa-user-plus overlay__item-icon"></i>
                <span>{{ 'header-menu-signup' | translate }}</span>
              </a>
            </li>
          </ng-container>
          <!-- menu items when logged in -->
          <ng-container *ngIf="isLoggedIn">
            <!-- my account -->
            <li class="overlay__item">
              <a
                class="overlay__link main-menu__link"
                id="qa_account-profile"
                data-testid="qa-account-profile-link"
                routerLinkActive="main-menu__link--active"
                [routerLink]="myAccountLink"
                (click)="onMenuItemClick()"
              >
                <i class="fa-regular fa-user-gear overlay__item-icon"></i>{{ 'header-menu-my-profile' | translate }}
              </a>
            </li>
            <!-- booking -->
            <li class="overlay__item">
              <a
                class="overlay__link main-menu__link"
                id="qa_account-booking"
                data-testid="qa-account-my-bookings-link"
                routerLinkActive="main-menu__link--active"
                [routerLink]="['/my-bookings']"
                (click)="onMenuItemClick()"
              >
                <i class="fa-regular fa-suitcase-rolling overlay__item-icon"></i>
                <span>{{ 'header-menu-booking' | translate }}</span>
              </a>
            </li>
          </ng-container>
          <!-- checkin/guest hub -->
          <li class="overlay__item">
            <a
              class="overlay__link main-menu__link"
              routerLinkActive="main-menu__link--active"
              id="qa_account-signup"
              data-testid="qa-checkin-guest-hub-link"
              [href]="guestHubUrl"
            >
              <i class="fa-regular fa-check-to-slot overlay__item-icon"></i>
              {{ 'header-menu-checkin-guesthub' | translate }}
            </a>
          </li>
          <!-- logout -->
          <li *ngIf="isLoggedIn" class="overlay__item">
            <a
              href="#"
              class="overlay__link main-menu__link"
              id="qa_account-logout"
              data-testid="qa-account-logout-btn"
              (click)="logOut($event)"
            >
              <i class="fa-regular fa-arrow-right-from-arc overlay__item-icon"></i
              >{{ 'header-menu-logout' | translate }}
            </a>
          </li>
        </ul>
      </div>
    </div>
    <i *ngIf="!isMobile" class="fa-regular fa-angle-down main-menu__link-icon main-menu__link-icon--user"></i>
  </div>
  <app-auth-modal
    [isAuthModalOpen]="isAuthModalOpen"
    [authModalActiveTab]="authModalActiveTab"
    (authModalClosed)="resetAuthModalActiveTab()"
  />
</div>

<app-info-modal
  *ngIf="modalVars[howItWorksId]"
  class="lm-modal"
  id="how-it-works"
  [modalOptions]="{
    modalSize: 'modal-xl',
    canGoFullScreenOnMobile: false,
    fullScreen: false,
    isNonSwiperModal: true
  }"
>
  <app-how-it-works [classList]="'header'" />
</app-info-modal>

<ng-template
  #menuItemWithoutDropdown
  let-title="title"
  let-titleMobile="titleMobile"
  let-icon="icon"
  let-href="href"
  let-id="id"
>
  <div class="main-menu__item main-menu__item--link">
    <a
      class="main-menu__link"
      routerLinkActive="main-menu__link--active"
      [id]="id"
      href="{{ href | localize }}"
      (click)="onMenuItemClick()"
    >
      <i *ngIf="isMobile" class="fa-regular {{ icon }} overlay__item-icon"></i>
      {{ titleMobile && isMobile ? (titleMobile | translate) : (title | translate) }}
      <i *ngIf="isMobile" class="fa-regular fa-angle-right overlay__item-icon-arrow"></i>
    </a>
  </div>
</ng-template>

<ng-template #helpCenterLinkTemplate>
  <div *ngIf="!isHelpPageActive" class="help-wrapper">
    <a
      aria-labelledby="how-it-works-title"
      class="main-menu__item item-how-it-works tooltip_container"
      target="_blank"
      [href]="helpCenterLink"
      (mouseleave)="hideHowItWorksTooltip()"
    >
      <ng-container [ngTemplateOutlet]="howItWorksIcon" />
    </a>
    <ng-container [ngTemplateOutlet]="howItWorksTooltipTemplate" />
  </div>
</ng-template>

<ng-template #howItWorksIcon>
  <i class="fa-regular fa-circle-question item-how-it-works__icon"></i>
</ng-template>

<ng-template #howItWorksTooltipTemplate>
  <span
    id="how-it-works-title"
    class="tooltip__text tooltip__text--bottom"
    [ngClass]="{ 'tooltip__text--visible': isHowItWorksTooltipVisible }"
  >
    {{ helpAndFaqsTooltipText }}
  </span>
</ng-template>
